module.exports = __webpack_public_path__ + "img/logoarquimarket.0e76fb59.png";